import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { MailX, Send } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { api, ApiError } from '@/lib/axios'

async function putResendActivationUser(email: string) {
  await api.backend.put(`/user/resend-activation/${email}`)
}

export function useResendActivationUser() {
  const { t } = useTranslation('registers')

  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    string
  >({
    mutationKey: ['/user/reactivate/id'],
    mutationFn: putResendActivationUser,
    onSuccess: () => {
      toast(Toast, {
        data: {
          type: 'success',
          icon: Send,
          title: t('users.resend_activation.toast_success.title'),
        },
      })
    },
    onError: (error) => {
      toast(Toast, {
        data: {
          type: 'danger',
          icon: MailX,
          title: t('users.resend_activation.toast_error.title'),
          description:
            error?.response?.data?.friendlyMessage ||
            t('users.resend_activation.toast_error.description'),
        },
      })
    },
  })

  return {
    handleReactivateUser: mutateAsync,
    isSendingReactivation: isPending,
  }
}
